@if (!isEditSessionActive() || !isInlineTableEditActive()) {
    <div class="entity-table-cell-inner">
        <span class="entity-table-text">
            {{ displayValue() }}
        </span>
    </div>
} @else {
    @if (columnNamesWithReference().includes(columnKey())) {
        <div class="min-w-28 max-w-72 flex flex-col">
            <app-select
                emptyOptionLabel="mapFilter.noValueSuggested"
                [additionalClasses]="
                    isEdited()
                        ? 'border-solid border-2 border-custom-blue hover:!bg-custom-light-blue'
                        : 'hover:!bg-custom-light-blue'
                "
                [defaultValue]="defaultAttributeOption"
                [enableSearch]="false"
                [isDisabled]="isDisabled()"
                [optionLoading]="optionLoading()"
                [options]="attributeOptions()"
                [sortOptions]="false"
                [(selectedOptions)]="selectedAttributeOption"
                (blur)="setStandardizedAttributesValue($event)"
                (inputFocus)="initAttributeValues()"
                (resetValue)="resetStandardizedAttributeValue()"
                (scrollEnd)="fetchNextPage()"
                (search)="search($event)" />

            @if (isReferredLayerNotFound()) {
                <span class="text-sm text-gray-500 whitespace-normal">
                    {{ 'editMode.noReferenceLayerInProject' | transloco }}
                </span>
            }
        </div>
    } @else {
        <div
            class="entity-table-cell-inner"
            [class]="classList()"
            [matTooltip]="isDisabled() && !isPendingDelete() ? ('editMode.fieldNotEditable' | transloco) : null">
            <div class="entity-table-input-wrapper">
                @if (isCellEditActive() && !effectiveReadonly()) {
                    @if (isDate()) {
                        <app-entity-table-date-cell
                            [edited]="isEdited()"
                            [info]="attributeInfo()!"
                            [value]="rawValue()"
                            (valueChange)="pushEdit($event)" />
                    } @else if (isDateAndHour()) {
                        <app-entity-table-date-hour-cell
                            [edited]="isEdited()"
                            [info]="attributeInfo()!"
                            [value]="rawValue()"
                            (valueChange)="pushEdit($event)" />
                    } @else {
                        <input
                            class="entity-table-input"
                            [attr.inputmode]="inputMode()"
                            [attr.type]="isNumeric() ? 'decimal' : 'text'"
                            [placeholder]="placeholder()"
                            [value]="displayValue() ?? ''"
                            (blur)="onCommit($event)"
                            (click)="$event.stopPropagation()"
                            (input)="onInput($event)"
                            (keydown.enter)="onCommit($event)" />
                    }
                } @else {
                    <span
                        class="entity-table-text"
                        [class.entity-table-text--disabled]="isDisabled()"
                        [class.entity-table-text--edited]="isEdited()">
                        {{ displayValue() }}
                    </span>
                }
            </div>
        </div>
    }

    <div class="entity-table-error-wrapper">
        @if (isCellEditActive() && !isDate() && hasErrors()) {
            @for (error of errorMessages(); track error) {
                <div class="entity-table-cell-error-text">
                    {{ error | transloco }}
                </div>
            }
        }
    </div>
}
